const list3 = [{
    id: 1,
    className: 'flex-1',
    name: '心脑肝养护',
    label: 6000,
    tag: ''
}, {
    id: 2,
    className: 'flex-1',
    name: '心脑肝养护-疗程',
    label: 15000,
    tag: ''
}, {
    id: 3,
    className: 'flex-1',
    name: '血液净化',
    label: 29800,
    tag: ''
}];

export const list = [list3];
export const expendList = [...list3];

export const item = JSON.parse(JSON.stringify({
    personName: "",
    personIdCard: "",
    personPhone: "",
    checkStartTime: "",
    productList: [],
    sum: 0,
}));
